import { PlusOutlined } from '@ant-design/icons';
import { Row, Col, Table, Tag } from 'antd';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, formatVND } from '../../helpers/common';
import Column from 'antd/es/table/Column';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { layDsLuongBoSung } from '../../services/luong';
import { DanhSachLuongBoSungResponse } from '../../models/luong/LuongBoSung';

const DanhSachLuongBoSung = () => {

    const menu: any = menuHelper.checkMultiPermission([Links.Luong.ChiTietLuongBoSung]);
    const [danhsach, setDanhSach] = useState<Array<DanhSachLuongBoSungResponse>>([]);
    const dispatch = useDispatch();

    const timkiem = async () => {
        try {
            dispatch(showLoadingScreen());
            var data = await layDsLuongBoSung();

            setDanhSach(data);
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
        };
    }

    useEffect(() => {
        timkiem();
    }, []);

    return (<section>
        <ContentHeader title="Quản lý Lương bổ sung NLĐ" />
        {
            menu[Links.Luong.ChiTietLuongBoSung] ?
                <Row className="form-group" gutter={8}>
                    <Col span={24}>
                        {
                            <Link to={Links.Luong.ChiTietLuongBoSung} className="hrm-btn float-right hrm-btn-warning" ><PlusOutlined className='align-self-center' rev="" />Thêm mới</Link>
                        }
                    </Col>
                </Row> : null
        }
        <div className="card card-primary">
            <Row>
                <Col span={24}>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={(danhsach || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                    >
                        <Column title="Thời gian bổ sung/quyết toán" dataIndex="thoiGian" key="thoiGian" />
                        <Column title="Tên" dataIndex="ten" key="ten" />
                        <Column title="Trạng thái" dataIndex="trangThai" key="trangThai"
                            render={(value: any, record: any) => {
                                switch (value) {
                                    case 0: return <Tag color="processing">Khởi tạo</Tag>;
                                    case 1: return <Tag color="success">Đã duyệt</Tag>;
                                    case 2: return <Tag color="warning">Trình duyệt</Tag>
                                }

                                return <Tag color="default">--</Tag>
                            }}
                        />                                               
                        <Column title="Là điều chỉnh của" dataIndex="tenQTDieuChinh" key="tenQTDieuChinh" />
                        <Column title="Số lượng nhân viên" dataIndex="soNhanVien" key="soNhanVien" />
                        <Column title="Nhóm nhân sự" key="nhomNhanSu" render={(value, record) => {
                            return <>{value === true ? "Người quản lý chuyên trách" : "Người lao động" }</>
                        }} />
                        <Column title="Tổng số tiền" dataIndex="tongSoTienConDuocNhan" key="tongSoTienConDuocNhan" render={(value, record) => {
                            return <>{formatVND(value)}</>
                        }} />                        
                        {
                            menu[Links.Luong.ChiTietLuongBoSung] &&
                            <Column
                                title=""
                                key="action"
                                render={(value, record, index) =>
                                (
                                    <Link key={"link" + index} className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.Luong.ChiTietLuongBoSung}?id=${value?.id}`}>Xem</Link>
                                )
                                }
                            />
                        }
                    </Table>
                </Col>
            </Row>
        </div>
    </section>
    );
};

export default DanhSachLuongBoSung;
